import React, { useState, useRef } from "react";
import axios from "axios";
import './cardstyle.css'; // You'll need to create this CSS file


const amexCardMask = ['0', '0', '0', '0', ' ', '0', '0', '0', '0', '0', '0', ' ', '0', '0', '0', '0', '0'];
const otherCardMask = ['0', '0', '0', '0', ' ', '0', '0', '0', '0', ' ', '0', '0', '0', '0', ' ', '0', '0', '0', '0'];


const CheckOut = ({ patientId, appointmentPrice, onPaymentComplete }) => {
  const [message, setMessage] = useState("");
  const [showCardForm, setShowCardForm] = useState(false);

  // Card form states
  const [isCardFlipped, setIsCardFlipped] = useState(false);
  const [focusElementStyle, setFocusElementStyle] = useState({});
  const [cardNumber, setCardNumber] = useState('');
  const [cardName, setCardName] = useState('');
  const [cardMonth, setCardMonth] = useState('');
  const [cardYear, setCardYear] = useState('');
  const [cardCvv, setCardCvv] = useState('');
  const [currentCardBackground, setCurrentCardBackground] = useState('1'); // Default background
  const minCardMonth = new Date().getMonth() + 1;
  const minCardYear = new Date().getFullYear();
  const [isInputFocused, setIsInputFocused] = useState(false);
  const [cardImage, setCardImage] = useState("default-card-image-url.jpg"); // Default card image
  const cardImages = {
    visa: "https://static.vecteezy.com/system/resources/thumbnails/020/975/570/small_2x/visa-logo-visa-icon-transparent-free-png.png",
    mastercard: "https://pngimg.com/d/mastercard_PNG16.png",
    amex: "https://d3.harvard.edu/platform-digit/wp-content/uploads/sites/2/2022/10/Amex-Logo-Long.png",
    discover: "https://1000logos.net/wp-content/uploads/2021/05/Discover-logo.png   ",
    rupay: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d1/RuPay.svg/2560px-RuPay.svg.png",
    troy:"https://i.pinimg.com/736x/a4/ed/cd/a4edcd18f6b4e531072cabc7ecafbf1f.jpg",
    default: "https://static.vecteezy.com/system/resources/thumbnails/020/975/570/small_2x/visa-logo-visa-icon-transparent-free-png.png"
};
    //refs
    const cardNumberRef = useRef(null);
    const cardNameRef = useRef(null);
    const cardDateRef = useRef(null);
    const focusElementRef = useRef(null);


    const getCardType = () => {
        const number = cardNumber.replace(/\s/g, ''); // Remove spaces for accurate checking
    
        let re = new RegExp("^4");
        if (number.match(re) != null) return "visa";
    
        re = new RegExp("^(34|37)");
        if (number.match(re) != null) return "amex";
    
        re = new RegExp("^5[1-5]");
        if (number.match(re) != null) return "mastercard";
    
        re = new RegExp("^6011");
        if (number.match(re) != null) return "discover";
    
        re = new RegExp("^(6521|6522|60|81|508)");
        if (number.match(re) != null) return "rupay"; // RuPay cards
    
        re = new RegExp("^9792");
        if (number.match(re) != null) return "troy";
    
        return "default"; // Default fallback
    };
    


    const focusInput = (e) => {
        const target = e.target;
        const ref = target.dataset.ref;
        let element = null;

        if (ref === 'cardNumber') {
            element = cardNumberRef.current;
        } else if (ref === 'cardName') {
            element = cardNameRef.current;
        } else if (ref === 'cardDate') {
            element = cardDateRef.current;
        }

        if (element) {
            const rect = element.getBoundingClientRect();
            setFocusElementStyle({
                width: `${rect.width}px`,
                height: `${rect.height}px`,
                transform: `translateX(${rect.left - element.offsetLeft}px) translateY(${rect.top - element.offsetTop}px)`
            });
        }
    };

    const blurInput = () => {
        setTimeout(() => {
            if (!isInputFocused) {
                setFocusElementStyle(null);
            }
        }, 300);
        setIsInputFocused(false);
    };

    const flipCard = (val) => {
        setIsCardFlipped(val);
    };


  const formatCardNumber = (value) => {
    const cleaned = value.replace(/\D/g, ''); // Remove non-numeric characters
    let formatted = '';

    if (getCardType() === 'amex') {
        formatted = cleaned.replace(/(\d{4})(\d{6})?(\d{5})?/, (_, p1, p2, p3) =>
            [p1, p2, p3].filter(Boolean).join(' ')
        );
    } else {
        formatted = cleaned.replace(/(\d{4})(\d{4})?(\d{4})?(\d{4})?/, (_, p1, p2, p3, p4) =>
            [p1, p2, p3, p4].filter(Boolean).join(' ')
        );
    }
    return formatted.trim();
};


const handleCardNumberChange = (e) => {
    let rawValue = e.target.value.replace(/\D/g, ''); // Remove non-numeric characters
    const maxLength = getCardType() === 'amex' ? 15 : 16;
    rawValue = rawValue.substring(0, maxLength); // Limit the length
    setCardNumber(formatCardNumber(rawValue));

    // Update card image based on detected type
    const detectedCardType = getCardType();
    setCardImage(cardImages[detectedCardType] || cardImages.default);
};
// const handleCardNumberChange = (e) => {
//     let rawValue = e.target.value.replace(/\D/g, ''); // Remove non-numeric characters
//     const maxLength = getCardType() === 'amex' ? 15 : 16;
//     rawValue = rawValue.substring(0, maxLength); // Limit the length
//     setCardNumber(formatCardNumber(rawValue));
// };


const handlePayment = async () => {
    // Basic validation
    if (!cardNumber || !cardName || !cardMonth || !cardYear || !cardCvv) {
      setMessage("Please fill in all card details.");
      return;
    }

    let paymentSuccess = false; // Track payment status
    let responseData = null; // Store the response data from the API

    try {
      const response = await axios.post("http://localhost:5000/api/payment", { // Use original endpoint
        amount:100, //  in cents
        patientId,
        cardNumber: cardNumber.replace(/\s/g, ''), // Remove spaces
        cardName,
        cardMonth,
        cardYear,
        cardCvv,
      });

      responseData = response.data; // Store the response

      if (response.data.success) {
        setMessage("Payment Successful!");
        clearForm();
        alert("Payment Successful!"); // Or use a better notification
        paymentSuccess = true;
      } else {
        setMessage("Oops! Payment Unsuccessful.");
        alert("Payment Failed!");
      }
    } catch (error) {
      setMessage("Payment Failed! Please try again.");
      console.error("Payment error:", error);
      alert("Payment Failed! Please try again.");
      responseData = { success: false, error: error.message }; // Store error info
    } finally {
      // Call the callback function regardless of success or failure
      if (onPaymentComplete) {
        onPaymentComplete({
          success: paymentSuccess,
          patientId,
          amount: appointmentPrice,
          cardNumber: cardNumber.replace(/\s/g, ''),
          cardName,
          cardMonth,
          cardYear,
          cardCvv,
          message: message, // Include the message
          responseData: responseData, // Include the full response data
        });
      }
    }
  };

  const clearForm = () => {
    setCardNumber("");
    setCardName("");
    setCardMonth("");
    setCardYear("");
    setCardCvv("");
  };

  const toggleCardForm = () => {
    setShowCardForm(true);
    setMessage(""); // Clear any previous messages
  };

  return (
    <div className="checkout-container">
      {!showCardForm ? (
        <button className="paywithcard" onClick={toggleCardForm}>Pay with Card</button>
      ) : (
        <>
         <div className="card-form-container">
        <div className="card-form">
            <div className="card-list">
                <div className={`card-item ${isCardFlipped ? '-active' : ''}`}>
                    <div className="card-item__side -front">
                        <div className={`card-item__focus ${focusElementStyle && Object.keys(focusElementStyle).length > 0 ? '-active' : ''}`} style={focusElementStyle} ref={focusElementRef}></div>
                        <div className="card-item__cover">
                            <img
                                src={"https://static.vecteezy.com/system/resources/thumbnails/011/412/771/small/abstract-vector-background-bg-purple-blue-pink-gradient-dots-pattern-curve-lines-photo.jpg"}
                                className="card-item__bg"
                                alt="Card Background"
                            />
                        </div>

                        <div className="card-item__wrapper">
                            <div className="card-item__top">
                                <img
                                    src="https://png.pngtree.com/png-vector/20231223/ourmid/pngtree-credit-card-chip-shopping-png-image_11198229.png"
                                    className="card-item__chip"
                                    alt="Card Chip"
                                />
                                <div className="card-item__type">
                                    {getCardType() && (
                                  
                                        <img 
                                        src={cardImages[getCardType()] || cardImages.default}
                                            alt="Card Type"
                                           
                                        />
                                    )}
                                </div>
                            </div>
                            <label htmlFor="cardNumber" className="card-item__number" ref={cardNumberRef}>
                                 {getCardType() === 'amex' ? (
                                    amexCardMask.map((n, index) => (
                                        <span key={index}>
                                            {index > 4 && index < 14 && cardNumber.length > index && n.trim() !== '' ? (
                                                <div className="card-item__numberItem">*</div>
                                            ) : cardNumber.length > index ? (
                                                <div className={`card-item__numberItem ${n.trim() === '' ? '-active' : ''}`}>{cardNumber[index]}</div>
                                            ) : (
                                                <div className={`card-item__numberItem ${n.trim() === '' ? '-active' : ''}`}>{n}</div>
                                            )}
                                        </span>
                                    ))
                                ) : (
                                    otherCardMask.map((n, index) => (
                                        <span key={index}>
                                           {index > 4 && index < 15 && cardNumber.length > index && n.trim() !== '' ? (
                                                <div className="card-item__numberItem">*</div>
                                            ) : cardNumber.length > index ? (
                                                <div className={`card-item__numberItem ${n.trim() === '' ? '-active' : ''}`}>{cardNumber[index]}</div>
                                            ) : (
                                                <div className={`card-item__numberItem ${n.trim() === '' ? '-active' : ''}`}>{n}</div>
                                            )}
                                        </span>
                                    ))
                                )}
                            </label>
                            <div className="card-item__content">
                                <label htmlFor="cardName" className="card-item__info" ref={cardNameRef}>
                                    <div className="card-item__holder">Card Holder</div>
                                    {cardName.length ? (
                                        <div className="card-item__name">
                                            {cardName.replace(/\s\s+/g, ' ').split('').map((n, index) => (
                                                <span className="card-item__nameItem" key={index}>
                                                    {n}
                                                </span>
                                            ))}
                                        </div>
                                    ) : (
                                        <div className="card-item__name">Full Name</div>
                                    )}
                                </label>
                                <div className="card-item__date" ref={cardDateRef}>
                                    <label htmlFor="cardMonth" className="card-item__dateTitle">
                                        Expires
                                    </label>
                                    <label htmlFor="cardMonth" className="card-item__dateItem">
                                        <span>{cardMonth || 'MM'}</span>
                                    </label>
                                    /
                                    <label htmlFor="cardYear" className="card-item__dateItem">
                                        <span>{cardYear ? String(cardYear).slice(2, 4) : 'YY'}</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card-item__side -back">
                        <div className="card-item__cover">
                            <img
                             src={"https://static.vecteezy.com/system/resources/thumbnails/011/412/771/small/abstract-vector-background-bg-purple-blue-pink-gradient-dots-pattern-curve-lines-photo.jpg"}
                                className="card-item__bg"
                                alt="Card Background"
                            />
                        </div>
                        <div className="card-item__band"></div>
                        <div className="card-item__cvv">
                            <div className="card-item__cvvTitle">CVV</div>
                            <div className="card-item__cvvBand">
                                {Array.from(cardCvv).map((_, index) => (
                                    <span key={index}>*</span>
                                ))}
                            </div>
                            <div className="card-item__type">
                                {getCardType() && (
                                    <img
                                    src={cardImages[getCardType()] || cardImages.default}
                                        className="card-item__typeImg"
                                        alt="Card Type"
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="card-form__inner">
                <div className="card-input">
                    <label htmlFor="cardNumber" className="card-input__label">
                        Card Number
                    </label>
                    <input
                        type="text"
                        id="cardNumber"
                        className="card-input__input"
                        value={formatCardNumber(cardNumber)}
                        onChange={handleCardNumberChange}
                        onFocus={focusInput}
                        onBlur={blurInput}
                        data-ref="cardNumber"
                        autoComplete="off"
                        maxLength={19}
                    />
                </div>
                <div className="card-input">
                    <label htmlFor="cardName" className="card-input__label">
                        Card Holders
                    </label>
                    <input
                        type="text"
                        id="cardName"
                        className="card-input__input"
                        value={cardName}
                        onChange={(e) => setCardName(e.target.value)}
                        onFocus={focusInput}
                        onBlur={blurInput}
                        data-ref="cardName"
                        autoComplete="off"
                    />
                </div>
                <div className="card-form__row">
                    <div className="card-form__col">
                        <div className="card-form__group">
                            <label htmlFor="cardMonth" className="card-input__label">
                                Expiration Date
                            </label>
                            <select
                                className="card-input__input -select"
                                id="cardMonth"
                                value={cardMonth}
                                onChange={(e) => setCardMonth(e.target.value)}
                                onFocus={focusInput}
                                onBlur={blurInput}
                                data-ref="cardDate"
                            >
                                <option value="" disabled>
                                    Month
                                </option>
                                {Array.from({ length: 12 }, (_, i) => i + 1).map((n) => (
                                    <option
                                        value={n < 10 ? '0' + n : n}
                                        key={n}
                                        disabled={n < minCardMonth && minCardYear === new Date().getFullYear()}
                                    >
                                        {n < 10 ? '0' + n : n}
                                    </option>
                                ))}
                            </select>
                            <select
                                className="card-input__input -select"
                                id="cardYear"
                                value={cardYear}
                                onChange={(e) => setCardYear(e.target.value)}
                                onFocus={focusInput}
                                onBlur={blurInput}
                                data-ref="cardDate"
                            >
                                <option value="" disabled>
                                    Year
                                </option>
                                {Array.from({ length: 12 }, (_, i) => i).map((n) => (
                                    <option value={n + minCardYear} key={n}>
                                        {n + minCardYear}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className="card-form__col -cvv">
                        <div className="card-input">
                            <label htmlFor="cardCvv" className="card-input__label">
                                CVV
                            </label>
                            <input
                                type="text"
                                className="card-input__input"
                                id="cardCvv"
                                maxLength="4"
                                value={cardCvv}
                                onChange={(e) => setCardCvv(e.target.value)}
                                onFocus={() => flipCard(true)}
                                onBlur={() => flipCard(false)}
                                autoComplete="off"
                            />
                        </div>
                    </div>
                </div>

                <button className="card-form__button" onClick={handlePayment}>Pay {appointmentPrice}</button><br/>
                <br/>
                <p>{message}</p>
            </div>
        </div>
    </div>


        
        </>
      )}


    </div>
  );
};

export default CheckOut;